import { CreateAsset } from '@/features/AssetCollection/CreateAsset/CreateAsset';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/asset_collection/create_asset')({
    component: CreateAsset,
});
